// extracted by mini-css-extract-plugin
export default {"menuItem":"iPYa4B7iQyFTxwRD5vcd","danger":"ozLOYixcsEOzCB2T3Oh3","icon":"HCKQlhQaRuDFzNk4VKt9","loading":"o1_TPFNHh0qA7suJoA15","img":"tozM163oiWQwD7kYvuPt"};